<template>
    <div class="relative">
        <BaseButton
            class="text-theme-icon"
            dusk="toggleTheme"
            :tooltip="localizations[lang].tooltips.themeTitle"
            :icon="currentThemeIcon"
            width="24px"
            height="24px"
            @click="toggleMenu"
        />

        <div
            v-if="isMenuOpen"
            :class="[
                'absolute',
                'right-0',
                'top-full',
                'bg-theme-bg',
                'rounded-lg',
                'shadow-lg',
                'border',
                'border-theme-border',
                'z-50',
                'min-w-36',
            ]"
        >
            <div class="flex items-center gap-1 p-2">
                <ThemeIcon :show-title="false" @changed-theme="toggleMenu" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseButton from './buttons/BaseButton.vue';
import ThemeIcon from './ThemeIcon.vue';

export default {
    name: 'ThemeSelector',
    components: {
        BaseButton,
        ThemeIcon,
    },
    data() {
        return {
            isMenuOpen: false,
        };
    },
    computed: {
        ...mapState(['ui', 'localizations', 'lang']),
        currentThemeIcon() {
            const currentOption =
                this.ui.themeOptions.find(option => option.value === this.ui.theme) || this.ui.themeOptions[0];
            return this.getIconForOption(currentOption);
        },
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        handleClickOutside(e) {
            if (this.$el.contains(e.target)) return;
            this.isMenuOpen = false;
        },
        getIconForOption(option) {
            return this.ui.theme === option.value ? option.solidIcon : option.icon;
        },
    },
};
</script>
